<template>
  <div class="guide-forecast">
    <div class="guide-forecast__current">
      <div class="current-info">
        <div class="current-info__icon">
          <span class="svg-icon d-inline-flex" aria-hidden="true">
            <svg
              class="svg-icon__svg"
              width="78px"
              height="78px"
              focusable="false"
            >
              <use
                :xlink:href="
                  `/img/static/svg-weather-sprites.svg#` + getCurrentMeteoIcon()
                "
              ></use>
            </svg>
          </span>
        </div>
        <div class="current-info__date">
          <span class="d-block mb-12 text-truncate w-100"
            >Dzisiaj, {{ getWeatherDay(0) }}</span
          >
          <span class="d-block current-info__temp"
            >{{ getCurrentTemp() }} &#176;C</span
          >
        </div>
      </div>
      <!-- TODO - zdjęcie per serwis, potrzebny dostęp do zasobów -->
      <img
        src="https://dcontent.inviacdn.net/shared/img/web-830/2020/5/28/m0/964406.jpg"
        alt=""
      />
    </div>
    <div class="guide-forecast__next">
      <div
        class="next-item"
        v-for="(item, idx) in forecastNextDaysData"
        :key="idx"
      >
        <div class="next-item__date">
          <span class="font-m"
            >{{ item.dayName }}<span class="d-md-none">, </span></span
          >
          <span>{{ item.date }}</span>
        </div>
        <div class="next-item__icon">
          <span class="svg-icon d-inline-flex" aria-hidden="true">
            <svg
              class="svg-icon__svg"
              width="64px"
              height="64px"
              focusable="false"
            >
              <use
                :xlink:href="`/img/static/svg-weather-sprites.svg#` + item.icon"
              ></use>
            </svg>
          </span>
        </div>
        <div class="next-item__temp">
          {{ item.tempMin }}-{{ item.tempMax }} &#176;C
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as CONFIG from "../config.js";

export default {
  name: "forecast-home-page-guide",
  props: {
    locid: String
  },
  data: () => ({
    url: "/getprzewodnikmeteo.json",
    meteo: {},
    forecastNextDaysData: []
  }),
  methods: {
    getGeoMeteo() {
      let pars = "locid=" + this.locid;
      return axios
        .get(CONFIG.API_URL + this.url + "?" + pars, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          }
        })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          alert("ERROR" + e);
        });
    },
    getWeatherDay(i) {
      if (
        this.meteo.dni &&
        this.meteo.dni.dzien[i] &&
        this.meteo.dni.dzien[i].data
      ) {
        return this.meteo.dni.dzien[i].data;
      } else {
        return "";
      }
    },
    getWeatherDayName(i) {
      if (
        this.meteo.dni &&
        this.meteo.dni.dzien[i] &&
        this.meteo.dni.dzien[i]["dzien-tygodnia"]
      ) {
        return this.meteo.dni.dzien[i]["dzien-tygodnia"];
      } else {
        return "";
      }
    },
    getWeatherTempMinC(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].tempMinC
      ) {
        return this.meteo.data.weather[i].tempMinC;
      } else {
        return "";
      }
    },
    getWeatherTempMaxC(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].tempMaxC
      ) {
        return this.meteo.data.weather[i].tempMaxC;
      } else {
        return "";
      }
    },
    getCurrentTemp() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.temp_C
      ) {
        return this.meteo.data.current_condition.temp_C;
      } else {
        return "";
      }
    },
    getCurrentMeteoIcon() {
      if (
        this.meteo.data &&
        this.meteo.data.current_condition &&
        this.meteo.data.current_condition.weatherIconUrl
      ) {
        return this.getImageName(
          this.meteo.data.current_condition.weatherIconUrl
        );
      } else {
        return "";
      }
    },
    getMeteoIcon(i) {
      if (
        this.meteo.data &&
        this.meteo.data.weather[i] &&
        this.meteo.data.weather[i].weatherIconUrl
      ) {
        return this.getImageName(this.meteo.data.weather[i].weatherIconUrl);
      } else {
        return "";
      }
    },
    getImageName(imageUrl) {
      if (imageUrl) {
        return imageUrl
          .split("\\")
          .pop()
          .split("/")
          .pop()
          .split(".")[0];
      } else {
        return "";
      }
    },
    getForecastNextDays() {
      let forecastDays = [];

      for (let i = 1; i <= this.meteo.data.weather.length - 1; i++) {
        forecastDays.push({
          date: this.getWeatherDay(i),
          dayName: this.getWeatherDayName(i),
          icon: this.getMeteoIcon(i),
          tempMin: this.getWeatherTempMinC(i),
          tempMax: this.getWeatherTempMaxC(i)
        });
      }
      this.forecastNextDaysData = forecastDays;
    }
  },
  mounted() {
    this.getGeoMeteo().then(data => {
      this.meteo = data.Meteo;
      this.getForecastNextDays();
    });
  }
};
</script>

<style lang="scss" scoped>
.guide-forecast {
  @media (min-width: $screen-sm) {
    display: flex;
    height: 192px;
  }

  @media (min-width: $screen-md) {
    height: 180px;
  }

  &__current {
    border-radius: 3px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin-bottom: 12px;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 160px;

    @media (min-width: $screen-sm) {
      margin-bottom: 0;
      margin-right: 24px;
      width: 45%;
      height: 100%;
    }

    @media (min-width: $screen-md) {
      margin-right: 12px;
      width: 40%;
    }

    > img {
      display: block;
      width: 100%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      position: absolute;
    }

    &::before {
      background: rgba(0, 76, 148, 0.75);
      background: linear-gradient(
        0deg,
        rgba(0, 76, 148, 0.9) 15%,
        rgba(0, 76, 148, 0) 75%
      );
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    .current-info {
      color: #fff;
      display: flex;
      align-self: flex-end;
      padding: 14px 16px;
      width: 100%;
      z-index: 2;

      &__icon {
        @media (max-width: $screen-sm-max) {
          margin-left: auto;
          order: 2;
        }

        @media (min-width: $screen-md) {
          margin-right: 32px;
        }

        > .svg-icon svg {
          @media (max-width: $screen-sm-max) {
            width: 68px;
            height: 68px;
          }
        }
      }

      &__date {
        line-height: 1;
        margin-top: auto;
        overflow: hidden;
      }

      &__temp {
        font-size: 36px;
        line-height: 1;

        @media (min-width: $screen-md) {
          font-size: 44px;
        }
      }
    }
  }

  &__next {
    width: 100%;

    @media (min-width: $screen-md) {
      display: flex;
      align-items: center;
    }

    .next-item {
      display: flex;
      align-items: center;

      @media (max-width: $screen-xs-max) {
        margin-bottom: 4px;
      }

      @media (max-width: $screen-sm-max) {
        border-radius: 2px;
        padding: 4px 12px;
        width: 100%;

        &:nth-child(even) {
          background-color: #f8f8f8;
        }
      }

      @media (min-width: $screen-md) {
        flex-direction: column;
        width: 25%;
      }

      &__date {
        @media (max-width: $screen-sm-max) {
          margin-right: auto;
        }

        @media (min-width: $screen-md) {
          margin-bottom: 12px;
          text-align: center;
        }

        > span {
          @media (max-width: $screen-xxxs-max) {
            display: block;
          }
          @media (min-width: $screen-md) {
            display: block;
          }
        }
      }

      &__icon {
        margin-left: 24px;

        @media (max-width: $screen-xs-max) {
          order: 2;
        }

        @media (min-width: $screen-sm) {
          margin-right: 24px;
        }

        @media (min-width: $screen-md) {
          margin-bottom: 12px;
        }

        > .svg-icon svg {
          @media (max-width: $screen-sm-max) {
            width: 40px;
            height: 40px;
          }
        }
      }

      &__temp {
        @media (max-width: $screen-sm-max) {
          @include font-m();
        }

        @media (min-width: $screen-md) {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
